import React from "react";

export function CloudServerIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <rect
        x="6"
        y="16"
        width="12"
        height="5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
      <path
        d="M6 18L8.25966 12.5435C8.64656 11.6092 9.5582 11 10.5694 11H13.325C14.2843 11 15.1591 11.5486 15.5641 12.4183C16.2255 13.8384 17.2446 16.0823 18 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M4.25825 13.9999C1.24727 12.6735 1.24727 9.35766 4.25811 8.03131C3.5 4.71545 7 3.49991 8.77463 4.71545C10 0.499973 18.5603 0.736391 17.8075 7.36823C21.5 6.5 23.8295 11.3472 20.0658 13.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
